import { UserService } from './../shared/services/user/user.service';
import { Component, OnInit, ViewEncapsulation,Inject, OnDestroy } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { Event } from '../shared/interface/event';
import { EventService } from "../shared/services/event/event.service";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { Site } from '../shared/interface/site';
import "rxjs/add/operator/debounceTime";
import { Subject } from 'rxjs/Subject';
import { CommonService } from "../shared/services/index";
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EventsComponent implements OnInit, OnDestroy {
  dataSource: Event[];
  pageLength: number;
  pageSize: number = 10;
  pageSizeOptions = [10, 25, 50];
  pageEvent: any;
  filter = {
    page: 1,
    limit: 10,
    where: {}
  };
  private subject: Subject<string> = new Subject();
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  searchLoading = 0;
  constructor(public dialog: MatDialog, private eventService: EventService, private commonService: CommonService,private userService:UserService) { }

  ngOnInit() {
    this.setList(this.filter);
    this.setList("", 1);
    this.eventService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if (["create", "update"].includes(data.action)) {
        this.setList(this.filter);
        this.setList("", 1);
      }
    });
    this.subject.debounceTime(200).pipe(takeUntil(this._unsubscribeAll)).subscribe(filterTerm => {
      this.filter.page = 1;
      this.filter.limit = 10;
      this.filter.where = {
        eventName: filterTerm
      };
      this.setList(this.filter);
      this.setList("", 1);
    });
  };

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  filterData(filterTerm) {
    this.subject.next(filterTerm);
    this.searchLoading = 1;
  }

  paginateData(pageEvent) {
    this.filter.page = pageEvent.pageIndex + 1;
    this.filter.limit = pageEvent.pageSize;
    this.setList(this.filter);
  }

  convertUserOffset(dateT){
    let convertedDate = this.userService.getOffsetconvertUtc(dateT,this.getClientTimeZone());
    return convertedDate;
  }

  getClientTimeZone():string{
    //get User offset
    let userOff = this.userService.getLoggedInUser();
    return userOff.settings.dateTimeFormat;
  }


  setList(filter = {}, loadCount = 0) {
    if (loadCount == 1) {
      this.eventService.list().pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.pageLength = res.length;
          this.searchLoading = 0;
        },
        err => { }
      );
      return false;
    }
    let filterString = this.commonService.buildFilter(filter);
    this.eventService.list(filterString).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.dataSource = res;
        this.searchLoading = 0;
      },
      err => { }
    );
  };

  openEventDialog = (data = {}) => {
    this.dialog.open(EventDialog, {
      data: data,
      height: 'auto',
      width: '800px',
      panelClass: 'full-modal'
    });
  };

  public delete(_id) {
    if (confirm(
      "Are you sure you want to remove this event?") == false) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);
    this.eventService.delete(_id).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      r => {

        if (this.dataSource.length == 0 && this.filter.page > 0) {
          this.filter.page -= 1;
          this.setList(this.filter);
          this.setList("", 1);
        }
      },
      e => {
        this.dataSource = temp;
      }
    );
  }
}

@Component({
  selector: 'event-dialog',
  templateUrl: 'event.dialog.html'
})
export class EventDialog implements OnDestroy {
  eventForm: FormGroup;
  siteList$: Observable<Site[]>;
  isSubmitted: number = 0;

  openingDays = [];
  operationalHrs = [];
  sitesList = [];
  sites = [];

  mapped = [];
  operationalHours = [];
  week: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EventDialog>,
    private commonService: CommonService,
    private userService:UserService
  ) {

    //this.siteList$ = this.eventService.siteMasterList();

    this.getSiteList();

    data = this.parseData(data);
    this.createForm(data);

    //commented to create multiple checkbox dropdown for zone selection
    // this.eventForm.controls['mapped'].valueChanges
    //   .debounceTime(400)
    //   .subscribe(name => {
    //     this.eventService.siteMasterList(name).subscribe(res => {
    //       if (res) {
    //         this.sitesList = res;
    //       }
    //     });
    //   });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  

  getSiteList() {
    this.eventService.siteMasterList().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (res) {
        this.sitesList = res;
      }
    });
  }

  selectFullWeek(value) {
    this.week.forEach((v, i) => {
      this.eventForm.get('operationalHours.' + i + '.activeDay').setValue(value);
      if (value) {
        this.eventForm.get('operationalHours.' + i + '.from').setValue(this.eventForm.get('defaultOperationalHours.from').value);
        this.eventForm.get('operationalHours.' + i + '.endOn').setValue(this.eventForm.get('defaultOperationalHours.endOn').value);
        this.eventForm.get('operationalHours.' + i + '.to').setValue(this.eventForm.get('defaultOperationalHours.to').value);
      } else {
        this.eventForm.get('operationalHours.' + i + '.from').setValue("");
        this.eventForm.get('operationalHours.' + i + '.endOn').setValue("");
        this.eventForm.get('operationalHours.' + i + '.to').setValue("");
      }
    })
  }

  convertDateTime(dateTime,isAdd){
  return this.commonService.getDateConverted(dateTime,"YYYY-MM-DD HH:mm:ss");
  }
  

  

  createForm = (data: Event) => {
    if (data && data._id) {
      // this.sites = data.mapped;
      data.mapped.forEach((v, i) => {
        this.sites.push(v.siteId);
      });
    }

    this.eventForm = this.fb.group({
      _id: [data._id],
      eventName: [data.eventName, Validators.compose([
        Validators.required]
      )],
      from: [this.convertDateTime(data.from,true), Validators.required],
      to: [this.convertDateTime(data.to,true), Validators.required],
      mapped: [this.sites, Validators.required],
      defaultOperationalHours: this.fb.group({
        endOn: [data.defaultOperationalHours.endOn, Validators.required],
        from: [this.dbTimeToPickerTime(data.defaultOperationalHours.from), Validators.required],
        // [
        //   data.defaultOperationalHours.from,
        //   Validators.compose([
        //     Validators.required,
        //     Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")
        //   ])
        // ],
        to: [this.dbTimeToPickerTime(data.defaultOperationalHours.to), Validators.required],
        // [
        //   data.defaultOperationalHours.to,
        //   Validators.compose([
        //     Validators.required,
        //     Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")
        //   ])
        // ]
      }),
      fullWeek: "",
      openingDays: [data.openingDays],
      operationalHours: this.fb.array([])
    });

    this.setOperationalHours(data.operationalHours);
  };

  dbTimeToPickerTime(time) {
    let dateToday = new Date();
    let timeArray = time.split(':');
    let datt = new Date(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate(), timeArray[0], timeArray[1], timeArray[2]);
    let convertedDate = this.commonService.getDateConverted(datt,"YYYY-MM-DD HH:mm:ss");
    return new Date(convertedDate);
    // return new Date(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate(), timeArray[0], timeArray[1], timeArray[2]);

  }



  pickerTimeToDBTime(pDate) {
    let dtf = pDate;
    let convertedDate = new Date(this.commonService.getDateConverted(dtf,"YYYY-MM-DD HH:mm:ss"));    
    let sdf2 =  this.addZero(convertedDate.getHours()) + ':' + this.addZero(convertedDate.getMinutes()) + ':' + this.addZero(convertedDate.getSeconds());
    // let sdf =  this.addZero(new Date(dtf).getHours()) + ':' + this.addZero(new Date(dtf).getMinutes()) + ':' + this.addZero(new Date(dtf).getSeconds());
    // console.log(sdf);
    return sdf2;
  }

  setOperationalHours(operationalHours: any = []) {
    let isFullWeek = 0;
    if (operationalHours.length > 0) {
      this.operationalHours.forEach((v, i) => {
        operationalHours.forEach(e => {
          if (v.day == e.day) {
            this.operationalHours[i].activeDay = true;
            this.operationalHours[i].from = this.dbTimeToPickerTime(e.from);
            this.operationalHours[i].endOn = e.endOn;
            this.operationalHours[i].to = this.dbTimeToPickerTime(e.to);
            isFullWeek += 1;
          }
        });
      });
    }
    if (isFullWeek == 7) {
      this.eventForm.get('fullWeek').setValue(true);
    }

    const ohFGs = this.operationalHours.map(oh => this.fb.group(oh));
    const ohFormArray = this.fb.array(ohFGs);
    this.eventForm.setControl("operationalHours", ohFormArray);
  };

  parseData(data: any) {
    this.week.forEach((v, i) => {
      this.operationalHours.push({
        day: i + 1,
        activeDay: false,
        endOn: "sameDay",
        from: "", //["", Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")],
        to: "" // ["", Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")]
      });
    });
    if (data && data._id) {

      if(data.defaultOperationalHours.from > data.defaultOperationalHours.to){
        data.defaultOperationalHours.endOn = data.defaultOperationalHours.endOn == "nextDay" ? "sameDay" : data.defaultOperationalHours.endOn;

         //array of multiple operational hours
         if (data.operationalHours.length > 0) {
            data.operationalHours.forEach(e => {
              if (e.from > e.to) {
                e.endOn = e.endOn == "nextDay" ? "sameDay" : e.endOn;
              }
            });
        }
    }
      return data;
    }
    return {
      _id: "",
      eventName: "",
      from: "",
      to: "",
      mapped: [this.mapped],
      defaultOperationalHours: {
        from: "",
        endOn: "sameDay",
        to: "",
      },
      fullWeek: "",
      openingDays: this.openingDays,
      operationalHours: this.operationalHrs
    };
  }

  getOperationalHours() {
    return <FormArray>this.eventForm.get('operationalHours');
  }

  //set operational hours to default on active
  setOhValue(value, i) {
    if (value) {
      this.eventForm.get('operationalHours.' + i + '.from').setValue(this.eventForm.get('defaultOperationalHours.from').value);
      this.eventForm.get('operationalHours.' + i + '.endOn').setValue(this.eventForm.get('defaultOperationalHours.endOn').value);
      this.eventForm.get('operationalHours.' + i + '.to').setValue(this.eventForm.get('defaultOperationalHours.to').value);
    } else {
      this.eventForm.get('operationalHours.' + i + '.from').setValue("");
      this.eventForm.get('operationalHours.' + i + '.endOn').setValue("");
      this.eventForm.get('operationalHours.' + i + '.to').setValue("");
    }
  }

  //commented to create multiple checkbox dropdown for zone selection
  //On select of autocomplete
  // onSiteSelect(site: any) {
  //   let keepGoing = true;

  //   this.sites.forEach((v, i) => {
  //     if (keepGoing) {
  //       if (v._id == site._id) {
  //         keepGoing = false;
  //         this.eventForm.controls['mapped'].setValue('');
  //       }
  //     }
  //   });

  //   if (keepGoing) {
  //     site.siteId = site._id;
  //     this.sites.push(site);
  //     this.eventForm.controls['mapped'].setValue('');
  //   }
  // }

  // //remove chip
  // remove(site: any): void {
  //   let index = this.sites.indexOf(site);

  //   if (index >= 0) {
  //     this.sites.splice(index, 1);
  //   }
  // };

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  blockInput($event) {
    $event.preventDefault();
  }

  onSubmit(form: any) {
    
    if (!this.eventForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    let tempOperationDays = [];
    let tempOperationHrs = [];

     let from = this.pickerTimeToDBTime(form.defaultOperationalHours.from);
    let tempF = from.split(':');

    let to = this.pickerTimeToDBTime(form.defaultOperationalHours.to);
    let tempT = to.split(':');

    form.defaultOperationalHours.from = `${tempF[0]}:${tempF[1]}:00`;
    form.defaultOperationalHours.to = `${tempT[0]}:${tempT[1]}:59`;

 //Since we are converting to UTC check for next day concept
  if(from > to)
    form.defaultOperationalHours.endOn = form.defaultOperationalHours.endOn == "sameDay" ? "nextDay" : form.defaultOperationalHours.endOn;


    //create array for opening days
    form.operationalHours.forEach((v, i) => {
      if (v.activeDay) {
        tempOperationDays.push(v.day);

        from = this.pickerTimeToDBTime(v.from);
        tempF = from.split(':');

        to = this.pickerTimeToDBTime(v.to);
        tempT = to.split(':');

        if(from > to)
          v.endOn = v.endOn == "sameDay" ? "nextDay" : v.endOn;

        //update from and to time
        v.from = `${tempF[0]}:${tempF[1]}:00`;
        v.to = `${tempT[0]}:${tempT[1]}:59`;
      }
    });
    form.openingDays = tempOperationDays;

    let currentTime: any = new Date;
    currentTime = this.addZero(currentTime.getHours()) + ':' + this.addZero(currentTime.getMinutes()) + ':' + this.addZero(currentTime.getSeconds());
    if (typeof form.from == 'object') {
      //get from date
      let fromDate = (form.from._i.year);

      let fMonth = ((parseInt(form.from._i.month) + 1).toString().length == 1) ? "0" + (form.from._i.month + 1) : (form.from._i.month + 1);
      fromDate += '-' + fMonth;

      let fDate = (form.from._i.date.toString().length == 1) ? "0" + form.from._i.date : form.from._i.date;
      fromDate += '-' + fDate + ' 00:00:00';//+ currentTime;

      //add from date
      form.from = this.convertDateTime(fromDate,false);//this.commonService.getLocalToUTCDate(new Date(fromDate));
    } else {
      // if (typeof form.from == 'string') {
      let date = new Date(form.from);
      let fDate: string = "";
      fDate = date.getFullYear() + '-' + this.addZero(date.getMonth() + 1) + '-' + this.addZero(date.getDate()) + ' 00:00:00'; //+ this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':' + this.addZero(date.getSeconds());
      form.from = this.convertDateTime(fDate,false);//this.commonService.getLocalToUTCDate(new Date(fDate));
    }
    

    if (typeof form.to == 'object') {
      //get to date
      let toDate = (form.to._i.year);

      let tMonth = ((parseInt(form.to._i.month) + 1).toString().length == 1) ? "0" + (form.to._i.month + 1) : (form.to._i.month + 1);
      toDate += '-' + tMonth;

      let tDate = (form.to._i.date.toString().length == 1) ? "0" + form.to._i.date : form.to._i.date;
      toDate += '-' + tDate + ' 23:59:59';//+ currentTime;

      //add to date
      form.to = this.convertDateTime(toDate,false);//this.commonService.getLocalToUTCDate(new Date(toDate));
    } else {
      // if (typeof form.to == 'string') {
      let date = new Date(form.to);
      let lDate: string = "";
      lDate = date.getFullYear() + '-' + this.addZero(date.getMonth() + 1) + '-' + this.addZero(date.getDate()) + ' 23:59:59' //+ this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':' + this.addZero(date.getSeconds());
      form.to = this.convertDateTime(lDate,false);//this.commonService.getLocalToUTCDate(new Date(lDate));
    }

    console.log("From :",form.from," To :" ,form.to);
    console.log("Submit Converted From :",this.convertDateTime(form.from,false)," Submit Converted To :" ,this.convertDateTime(form.to,false));

    //modify default operational hours to add seconds
    // if (form.defaultOperationalHours.from.length < 8) {
    //   form.defaultOperationalHours.from += ":00";
    // }
    // if (form.defaultOperationalHours.to.length < 8) {
    //   form.defaultOperationalHours.to += ":00";
    // }
    

    //commented to create multiple checkbox dropdown for zone selection
    //modify mapped array
    let tempPush = [];
    // this.sites.forEach((v, i) => {
    //   let tempMappedSites: any = {};
    //   tempMappedSites.siteId = v.siteId;
    //   tempMappedSites.siteName = v.siteName;
    //   tempMappedSites.mappedFullSite = 1;
    //   tempMappedSites.zones = [];
    //   tempPush.push(tempMappedSites);
    // });

    form.mapped.forEach((v, i) => {
      let tempMappedSites: any = {};
      tempMappedSites.siteId = v;
      tempMappedSites.mappedFullSite = 1;
      tempMappedSites.zones = [];
      tempPush.push(tempMappedSites);
    });

    form.mapped = tempPush;

    // create event
    if (form._id == "") {
      this.eventService.create(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.dialogRef.close();
          this.eventService.sendAction("create", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      // Update event
      form.eventId = form._id;
      this.eventService.update(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.dialogRef.close();
          this.eventService.sendAction("update", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }
}





// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/events/events.component.ts